import { render } from "./CustomerContactModal.vue?vue&type=template&id=5e6daadf&scoped=true&ts=true&lang=pug"
import script from "./CustomerContactModal.vue?vue&type=script&lang=ts"
export * from "./CustomerContactModal.vue?vue&type=script&lang=ts"

import "./CustomerContactModal.vue?vue&type=style&index=0&id=5e6daadf&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6daadf"]])

export default __exports__